import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SnackBarModal from '@components/SnackBar';
import { hideSnackBar as actionHideSnackBar } from '@store/common/actions';

const SnackBarLoggedScreen = ({ existNavBar }) => {
  const { snackBar } = useSelector((state) => state.logged);

  const { title, showSnackBar, ...propsSnackBar } = snackBar;

  const dispatch = useDispatch();

  const hideSnackBar = () => {
    dispatch(actionHideSnackBar());
  };

  return (
    <SnackBarModal
      title={title}
      open={showSnackBar}
      id="snack-bar"
      handleClose={() => hideSnackBar()}
      onBlur={() => hideSnackBar()}
      existNavBar={existNavBar}
      {...propsSnackBar}
    />
  );
};

export default SnackBarLoggedScreen;
